export default {
	history: {
		saveInFile: "Save to file",
		server: "Server:",
		lastHistory: "Last History",
		historyFilesList: "List of history files",
		noCronOnCurrentServer: "There is no cron on the current server",
	},
	scheduler: {
		schedulerStructure: "Schedule structure",
		cronHelp: "CRON Help",
		schedulerConsistOfPackeges: "A schedule consists of packages that are scheduled to run at a specific time.",
		eachPackageConsistsOfAnArbitraryNumber: "Each package consists of an arbitrary number of steps.",
		stepIsATemplateThatWorksWithSpecificTasks: "A step is a template that works with specific application tasks.",
		stepCreate: "Step creation",
		forStepCreateNeedSelectApp: "To create a step, you must select an application.",
		AfterThatListOfTemplatesCreatedForThisWillAppear: "This will display a list of templates that have been created for this application.",
		ifNeededSelectBaseYouNeedSelectItFromCurrentList: "If you need to specify a base in the task, you will need to select it from the following list of application bases.",
		stepEdit: "Step Editing",
		stepEditError: "You cannot edit the bases of the created step, but you can delete a specific one and create a new step in its place.",
		stepsCanBeRearranged: "Steps can be rearranged and added / removed from anywhere in the package using the appropriate buttons.",
		stepsEditWarning: "If one of the steps in a package was created from a template that was later modified, there will be a corresponding entry opposite this package as a whole and the step in particular.",
		packageCanHaveOneSchedule: "A package can have one schedule, which can be set on a special form.",
		packagesCanBeSortedByNameOrDate: "Packages can be sorted by their name or by the hour they run in the schedule.",
		newChanges: "New Changes",
		version: "version",
		nowYouCanCreateTasksCopy: "Now you can create copies of tasks when creating / editing a step based on a template.",
		allBasesAndQuanityAdded: "To the right of the task there are two new elements: the 'all bases' button and the 'count' field.",
		allBasesElementCanCreateAllCopiesOfTasks: "'All databases' will create as many copies of the task as there are databases in the application and automatically link all copies to the corresponding databases. Visible only if the task needs to enter a database.",
		quanityElementCreateCopiesOfCurrentTask: "'Amount' will create copies of the current task the number of times entered (the existing task is taken into account when creating).",
		cronExportPreview: "CRON export preview",
		cancel: "Cancel",
		export: "Export",
		server: "Server:",
		cronCreate: "Create CRON",
		cronExport: "Export CRON",
		cronEdit: "CRON Editing",
		templatesEdit: "Editing templates",
		onCurrentServerCronNotFound: "CRON not found on this server.",
		cronNotExported: "Cron is not exported"
	}
};
